<div class="mat-dialog-header">
  <div mat-dialog-title>
    <mat-icon class="circle" fontIcon="ec_option"></mat-icon>
    <h1>{{ "CONFIGURATION_AREA.DIALOGS.SETTINGS.TITLE" | translate }}</h1>
  </div>
  <button class="big" mat-button (click)="closeDialog()">
    <mat-icon fontIcon="ec_building_delete_address"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="settings-tab-group">
    <tpm-tabs [tabs]="tabs" [active]="tab()" (activeTabChange)="tab.set($event)"></tpm-tabs>
    <ng-container [ngSwitch]="tab()">
      <app-ca-municipal-settings
        *ngSwitchCase="'municipalSettings'"
        [form]="form.get('municipality')"
      ></app-ca-municipal-settings>
      <app-ca-contact-settings
        *ngSwitchCase="'contactSettings'"
        [form]="form.get('contactPerson')"
      ></app-ca-contact-settings>
      <app-ca-module-settings *ngSwitchCase="'moduleSettings'" [form]="form.get('modules')"></app-ca-module-settings>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <p class="note">{{ "CONFIGURATION_AREA.DIALOGS.SETTINGS.ACTIONS.NOTE" | translate }}</p>
  <button ene-outline-button size="large" (click)="closeDialog()">
    {{ "APP.CANCEL" | translate | uppercase }}
  </button>
  <button ene-filled-button size="large" [disabled]="form.invalid" (click)="closeDialog(true)">
    {{ "CONFIGURATION_AREA.DIALOGS.SETTINGS.ACTIONS.SUBMIT" | translate }}
  </button>
</mat-dialog-actions>
